import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import createGenerateClassName from '@material-ui/core/styles/createGenerateClassName'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import jssPreset from '@material-ui/core/styles/jssPreset'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import JssProvider from 'react-jss/lib/JssProvider'
import { BrowserRouter, Route } from 'react-router-dom'

import AppFrame from './AppFrame'
import AdminApi from './api/AdminApi'
import SnackMessages from './components/molecules/SnackMessages'
import AdminDashboard from './components/page/AdminDashboard'
import AdminLoginPage from './components/page/AdminLoginPage'
import AdminLoginResetPasswordPage from './components/page/AdminLoginSetPasswordPage'
import AdminVersionControlPage from './components/page/AdminVersionControlPage'
import AtlasDashboardPage from './components/page/AtlasDashboards/AtlasDashboardPage'
import AtlasOverviewPage from './components/page/AtlasDashboards/AtlasOverviewPage'
import ModelDetails from './components/page/ModelViewWrapper'
import ModelList from './components/page/ModelViewWrapper'
import SynchronizationPage from './components/page/SynchronizationPage'
import ApiConnector from './shared/api/ApiConnector'
import { ApiProvider } from './shared/api/ApiContext'
import PortalTheme, { THEME } from './shared/assets/styles/theme'
import Wizard from './shared/components/organisms/WizardPopup'
import { createPageWrapper } from './shared/components/pages'
import ErrorHandler from './shared/components/pages/ErrorHandler'
import AdminLoginResetPage from './shared/components/pages/ResetPasswordPage'
import PopupWrapper from './shared/components/popup/PopupWrapper'
import GenericMessagePage from './shared/components/templates/GenericMessagePage'
import captcha from './shared/utils/captcha'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const generateClassName = createGenerateClassName()

const apiConnector = new ApiConnector(process.env.REACT_APP_API_URL)
const adminApi = new AdminApi(apiConnector)

const componentByName = {
  ModelDetails,
  ModelList,
  AdminLoginPage,
  AdminLoginResetPage,
  AdminLoginResetPasswordPage,
  AdminDashboard,
  AtlasOverviewPage,
  AtlasDashboardPage,
  AdminVersionControlPage,
  GenericMessagePage,
  SynchronizationPage,
  Wizard,
}

const getComponentByName = (name) => {
  // console.log('App.js -> getComponentByName -> ', name)
  return componentByName[name]
}

// Yo dawg, I heard you liked wrappers, so I wrapped your wrapper in another wrapper
const PopupWrapperWrapper = (props) => <PopupWrapper {...props} maxWidth={'90vw'} maxHeight={'90vh'} />

let PageWrapper = createPageWrapper({
  getComponentByName,
  AppFrame,
  PopupWrapper: PopupWrapperWrapper,
  locale: 'en',
})

class App extends React.PureComponent {
  state = {}

  constructor(props) {
    super(props)

    this.state = {
      theme: createMuiTheme(THEME),
    }
  }

  handleRouteChange = ({ pageData: { appFrame } = {} }) => {
    captcha(appFrame)
  }

  handleThemeChange = (newTheme) => {
    if (newTheme.direction) document.body.dir = newTheme.direction
    this.setState({ theme: createMuiTheme({ ...THEME, ...newTheme }) })
  }

  render() {
    const { theme } = this.state

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <PortalTheme.Provider value={this.handleThemeChange}>
          <MuiThemeProvider theme={theme}>
            <BrowserRouter>
              <ErrorHandler>
                <ApiProvider api={adminApi}>
                  <SnackbarProvider maxSnack={4} dense>
                    <SnackMessages />
                    <Route
                      render={(props) => <PageWrapper {...props} onRouteChange={this.handleRouteChange} />}
                    />
                  </SnackbarProvider>
                </ApiProvider>
              </ErrorHandler>
            </BrowserRouter>
          </MuiThemeProvider>
        </PortalTheme.Provider>
      </JssProvider>
    )
  }
}

export default App
